import { createSignal } from 'solid-js';
import { UnreachableCaseError } from 'ts-essentials';

import type {
  SelectionTreeChildLoadTransition,
  SelectionTreeChildLoads,
} from './selection-tree-child-loads.types';

const withoutId = (
  current: ReadonlySet<string>,
  nodeId: string
): ReadonlySet<string> => {
  if (!current.has(nodeId)) return current;
  const next = new Set(current);
  next.delete(nodeId);
  return next;
};

const withId = (
  current: ReadonlySet<string>,
  nodeId: string
): ReadonlySet<string> => {
  if (current.has(nodeId)) return current;
  const next = new Set(current);
  next.add(nodeId);
  return next;
};

export const createSelectionTreeChildLoads = (): SelectionTreeChildLoads => {
  const [failedIds, setFailedIds] = createSignal<ReadonlySet<string>>(
    new Set()
  );

  const transition = (
    nodeId: string,
    event: SelectionTreeChildLoadTransition
  ): void => {
    setFailedIds((current) => {
      switch (event) {
        case 'start':
          return withoutId(current, nodeId);
        case 'fail':
          return withId(current, nodeId);
        default:
          throw new UnreachableCaseError(event);
      }
    });
  };

  return { failedIds, transition };
};
